// Product name shown in the UI and emails.
export const PRODUCT_NAME = "SenseGuard";
